import React from "react";
import { object } from "prop-types";
import { clamp } from "lodash";

import ComponentContainer from "../../layouts/component-container";
import TinyCard from "../../molecules/TinyCard";
import CustomSlider from "../../atoms/CustomSlider";

import { useDevice } from "../../utils/react-utils";

import "./tiny-four-news-card.m.css";

const TinyFourNewsCard = ({ collection }) => {
  if (!(collection && collection.items && collection.items.length)) return null;

  const { mobile, tab } = useDevice();

  const {
    items = [],
    "associated-metadata": {
      theme = "default",
      number_of_stories_to_show: numberOfStoriesToShow,
      number_of_collections_to_show: numberOfCollection,
    } = {},
  } = collection;

  const childCollection = items
    .filter(({ type, items }) => type === "collection" && items.find(({ type }) => type === "story"))
    .slice(0, clamp(numberOfCollection, 4));
  let stories = [];

  if (numberOfCollection === 0) {
    stories = items
      .filter(({ type }) => type === "story")
      .slice(0, clamp(numberOfStoriesToShow, 4))
      .map(({ story }) => story);
  } else {
    for (const col of childCollection) {
      const item = col.items.find(({ type }) => type === "story");
      item?.story && stories.push(item.story);
    }
  }

  return (
    <ComponentContainer
      className={theme}
      styleName={`base ${theme === "default" ? "default-theme" : ""}`}
      collection={collection}
    >
      <div styleName="container">
        <div>
          <CustomSlider
            isNavigation={false}
            slidesPerView={{ mobileSlides: 1.2, tabSlides: 2.6, desktopSlides: 4 }}
            spacing={{ mobileSpace: 16, tabSpace: 24, desktopSpace: 32 }}
            isNoPaddingMobile={true}
            allowTouchMove={mobile || tab}
          >
            {stories.map((story, index) => (
              <TinyCard
                story={story}
                key={index}
                className="tiny-card"
                collection={numberOfCollection === 0 ? null : childCollection[index]}
              />
            ))}
          </CustomSlider>
        </div>
      </div>
    </ComponentContainer>
  );
};

TinyFourNewsCard.propTypes = {
  collection: object,
};

TinyFourNewsCard.storyLimit = 4;
TinyFourNewsCard.nestedCollectionLimit = [1, 1, 1, 1];

export default TinyFourNewsCard;
